import { ArenaOpsUsdtSchema } from "./arena-ops-filters.dto";
import { z } from "zod";

/**
 * P4a — cash in, aggregated from DEPOSIT **movements**. Never from
 * `CedeArenaDeposit`: that table is a UI lifecycle row covering a minority of
 * deposits, so a tile built on it understates cash-in badly.
 */
export const ArenaOpsMoneyDepositsResponseSchema = z.object({
  totalUsdt: ArenaOpsUsdtSchema,
  movementCount: z.number().int(),
  uniqueDepositors: z.number().int(),
  series: z.array(
    z.object({
      bucketStart: z.iso.datetime(),
      count: z.number().int(),
      amountUsdt: ArenaOpsUsdtSchema,
    }),
  ),
});
export type ArenaOpsMoneyDepositsResponse = z.infer<typeof ArenaOpsMoneyDepositsResponseSchema>;
